import * as React from "react";

export const IconMoreHoriz = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M4.99967 8.33398C4.08301 8.33398 3.33301 9.08398 3.33301 10.0007C3.33301 10.9173 4.08301 11.6673 4.99967 11.6673C5.91634 11.6673 6.66634 10.9173 6.66634 10.0007C6.66634 9.08398 5.91634 8.33398 4.99967 8.33398ZM14.9997 8.33398C14.083 8.33398 13.333 9.08398 13.333 10.0007C13.333 10.9173 14.083 11.6673 14.9997 11.6673C15.9163 11.6673 16.6663 10.9173 16.6663 10.0007C16.6663 9.08398 15.9163 8.33398 14.9997 8.33398ZM9.99967 8.33398C9.08301 8.33398 8.33301 9.08398 8.33301 10.0007C8.33301 10.9173 9.08301 11.6673 9.99967 11.6673C10.9163 11.6673 11.6663 10.9173 11.6663 10.0007C11.6663 9.08398 10.9163 8.33398 9.99967 8.33398Z"
      fill="currentColor"
    />
  </svg>
);
